import Grid from '@mui/material/GridLegacy';
import React from 'react';
import { spaces } from '../../../../assets/styles/themes/tokens';
import { getTemplatePromptsByView } from '../utils';
import AIFeatureCard from './AIFeatureCard';
import { TemplatePrompts } from '@kimuno/api-sdk/lib/types/common/Conversation';
import { ActiveView } from '../constants';
import { IconName } from '../../../../utils/getMuiIcon';

export interface TemplatePromptItem {
  id: string;
  title: string;
  subheader: string;
  icon: IconName;
  chip?: 'new' | 'beta';
}

interface BaseProps {
  isExtended: boolean;
  gridItemProps?: {
    xs?: number;
    sm?: number;
    md?: number;
  };
}

type ViewBasedProps = BaseProps & {
  activeView: ActiveView.FREE_DRAFT_ENTRY | ActiveView.UNIT_ENTRY;
  onPromptClick: (title: string, subheader: string, id: TemplatePrompts) => void;
  items?: never;
};

type ItemsBasedProps = BaseProps & {
  items: TemplatePromptItem[];
  onPromptClick?: (title: string, subheader: string, id: TemplatePrompts) => void;
  activeView?: never;
};

type AIAssistantTemplatePromptListProps = ViewBasedProps | ItemsBasedProps;

const AIAssistantTemplatePromptList: React.FC<AIAssistantTemplatePromptListProps> = ({
  activeView,
  items,
  isExtended,
  onPromptClick,
  gridItemProps,
}) => {
  const defaultGridProps = {
    xs: 12,
    sm: 6,
    md: isExtended ? 3 : 6,
  };

  const finalGridProps = gridItemProps || defaultGridProps;
  const displayItems: TemplatePromptItem[] = items || (activeView ? getTemplatePromptsByView(activeView) : []);

  return (
    <Grid container spacing={1} sx={{ paddingTop: spaces.md }}>
      {displayItems.map(({ id, title, subheader, icon, chip }) => (
        <Grid
          item
          key={id}
          xs={finalGridProps.xs}
          sm={finalGridProps.sm}
          md={finalGridProps.md}
        >
          <AIFeatureCard
            title={title}
            icon={icon}
            description={subheader}
            chip={chip}
            testId={`ai-assistant-template-prompt-card-${id}`}
            onClick={() => onPromptClick?.(title, subheader, id as TemplatePrompts)}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default AIAssistantTemplatePromptList;
